import { combineReducers } from 'redux'
import {reducers as audioGuideReducers} from './reducers'

const reducers = combineReducers({
    audioGuideReducers
})

export {reducers}